import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './RoomTypeChipContent.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

type Props = {
  displayName: string;
  price: number;
  i18n: I18nService;
};

const RoomTypeChipContent = ({
  displayName,
  i18n: { formatCurrency, translate },
  price,
}: Props) => (
  <div className={cls('RoomTypeChipContent')}>
    <BpkText
      textStyle={TEXT_STYLES.footnote}
      className={cls('RoomTypeChipContent__displayName')}
    >
      {displayName}
    </BpkText>
    <BpkText
      textStyle={TEXT_STYLES.label1}
      className={cls('RoomTypeChipContent__price')}
    >
      {translate('ktxtHotelDetail_PriceFrom', { price: formatCurrency(price) })}
    </BpkText>
  </div>
);

export default withI18n(RoomTypeChipContent);
